import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage1 from "./pages/LoginPage1";
import HomePage from "./pages/HomePage";
import DataUsagePage from "./pages/DataUsagePage";
import ResultPage from "./pages/ResultPage";
import SendMessagePage from "./pages/SendMessagePage";
import DeviceInfoPage from "./pages/DeviceInfoPage";
import DeviceDiagnose from "./pages/DeviceDiagnose";
import DataInfoResultPage from "./pages/DataInfoResultPage";
import DeviceDiagnoseResultPage from "./pages/DeviceDiagnoseResultPage";
import FetchBulkDataPage from "./pages/FetchBulkDataPage";
import PacketDecodePage from "./pages/PacketDecodePage";

const isAuthenticated = () => {
  return !!localStorage.getItem("tnt_userid") && !!localStorage.getItem("tnt_orgid");
};

const PrivateRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage1 />} />
        <Route path="/home" element={<PrivateRoute element={<HomePage />} />} />
        <Route path="/data-usage" element={<PrivateRoute element={<DataUsagePage />} />} />
        <Route path="/result" element={<PrivateRoute element={<ResultPage />} />} />
        <Route path="/send-sms" element={<PrivateRoute element={<SendMessagePage />} />} />
        <Route path="/device-info" element={<PrivateRoute element={<DeviceInfoPage />} />} />
        <Route path="/device-diagnose" element={<PrivateRoute element={<DeviceDiagnose />} />} />
        <Route path="/data-info-result" element={<PrivateRoute element={<DataInfoResultPage />} />} />
        <Route path="/device-diagnose-result" element={<PrivateRoute element={<DeviceDiagnoseResultPage />} />} />
        <Route path="/fetch-bulk-data" element={<PrivateRoute element={<FetchBulkDataPage />} />} />
        <Route path="/packet-decode" element={<PrivateRoute element={<PacketDecodePage />} />} />
      </Routes>
    </Router>
  );
}

export default App;
